import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { FontSizeService } from './services/font-size.service';
import { PathwaysConfirmDialogComponent } from './components/pathways-confirm-dialog/pathways-confirm-dialog.component';
import { AccountSettingsDialogComponent } from './components/account-settings-dialog/account-settings-dialog.component';
import { StaticryptPassphraseDialogComponent } from './components/staticrypt-passphrase-dialog/staticrypt-passphrase-dialog.component';
import { PiSendOptionsDialogComponent } from './components/pi-send-options-dialog/pi-send-options-dialog.component';
import { UserMenuNavigationLoadingService } from './services/user-menu-navigation-loading.service';
import { AppVersionService } from './services/app-version.service';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';
import { MaintenanceOverlayComponent } from './components/maintenance-overlay/maintenance-overlay.component';
import { WhatsNewModalComponent } from './components/whats-new-modal/whats-new-modal.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';

// PAT-203 — root shell hosts maintenance mode UI + boots AppVersionService SSE.
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    PathwaysConfirmDialogComponent,
    AccountSettingsDialogComponent,
    StaticryptPassphraseDialogComponent,
    PiSendOptionsDialogComponent,
    MaintenanceBannerComponent,
    MaintenanceOverlayComponent,
    WhatsNewModalComponent,
    FeedbackDialogComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Pathways-AI';
  readonly userMenuNavLoading = inject(UserMenuNavigationLoadingService);
  // Injecting AppVersionService here boots the SSE connection and status check on app start
  readonly versionSvc = inject(AppVersionService);

  constructor(
    private theme: ThemeService,
    private fontSize: FontSizeService,
  ) {}

  ngOnInit(): void {
    this.theme.applyToDocument();
    this.fontSize.applyToDocument();
  }
}
